import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, isWidthUp, withWidth } from "@material-ui/core";
// import CodeIcon from "@material-ui/icons/Code";
// import BuildIcon from "@material-ui/icons/Build";
// import ComputerIcon from "@material-ui/icons/Computer";
// import BarChartIcon from "@material-ui/icons/BarChart";
// import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
// import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
// import CloudIcon from "@material-ui/icons/Cloud";
// import MeassageIcon from "@material-ui/icons/Message";
// import CancelIcon from "@material-ui/icons/Cancel";
import calculateSpacing from "./calculateSpacing";
import FeatureCard from "./FeatureCard";

// const iconSize = 30;

const features = [
  {
    color: "#00C853",
    headline: "50%",
    text:
      "of the global population will experience a mental health challenge at some point in their lives.",
      // icon: <Typography variant="h4" style={{ fontWeight: 700, color: "#361C10" }}>1</Typography>,
      icon: <Typography variant="h4" style={{ fontWeight: 700 }}>1</Typography>,
    mdDelay: "0",
    smDelay: "0"
  },
  {
    color: "#6200EA",
    headline: "970M",
    text:
      "people globally are living with a mental disorder.",
      icon: <Typography variant="h4" style={{ fontWeight: 700 }}>2</Typography>,
    // icon: <CalendarTodayIcon style={{ fontSize: iconSize }} />,
    mdDelay: "200",
    smDelay: "200"
  },
  {
    color: "#0091EA",
    headline: "3 in 5",
    text:
      "people with a mental illness avoid seeking support due to fear of being stigmatized",
    // icon: <MeassageIcon style={{ fontSize: iconSize }} />,
    icon: <Typography variant="h4" style={{ fontWeight: 700}}>3</Typography>,
    mdDelay: "400",
    smDelay: "0"
  },
  {
    color: "#d50000",
    headline: ">66%",
    text:
      "of people with mental health conditions globally lack access to the care they need.",
    // icon: <ComputerIcon style={{ fontSize: iconSize }} />,
    icon: <Typography variant="h4" style={{ fontWeight: 700 }}>4</Typography>,
    mdDelay: "0",
    smDelay: "200"
  },
  {
    color: "#DD2C00",
    headline: "42%",
    text:
     "of American adults cannot afford mental health care due to its high cost",
    // icon: <BarChartIcon style={{ fontSize: iconSize }} />,
    icon: <Typography variant="h4" style={{ fontWeight: 700 }}>5</Typography>,
    mdDelay: "200",
    smDelay: "0"
  },
  {
    color: "#64DD17",
    headline: ">75%",
    text:
      "of people in low and middle-income countries cannot afford mental health care",
    // icon: <HeadsetMicIcon style={{ fontSize: iconSize }} />,
    icon: <Typography variant="h4" style={{ fontWeight: 700}}>6</Typography>,
    mdDelay: "400",
    smDelay: "200"
  },
  // {
  //   color: "#304FFE",
  //   headline: "Feature 7",
  //   text:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
  //   icon: <CloudIcon style={{ fontSize: iconSize }} />,
  //   mdDelay: "0",
  //   smDelay: "0"
  // // },
  // {
  //   color: "#C51162",
  //   headline: "Feature 8",
  //   text:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
  //   icon: <CodeIcon style={{ fontSize: iconSize }} />,
  //   mdDelay: "200",
  //   smDelay: "200"
  // },
  // {
  //   color: "#00B8D4",
  //   headline: "Feature 9",
  //   text:
  //     "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et.",
  //   icon: <CancelIcon style={{ fontSize: iconSize }} />,
  //   mdDelay: "400",
  //   smDelay: "0"
  // }
];

function FeatureSection(props) {
  const { width } = props;
  return (
    <div style={{ backgroundColor: "#FFFFFF" }}>
      <div className="container-fluid lg-p-top">
        <Typography variant="h3" align="center" className="lg-mg-bottom"
        style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 400,
          color: "#361C10"
        }}
        >
          Our Current Reality
        </Typography>
        <div className="container-fluid">
          <Grid container spacing={calculateSpacing(width)}>
            {features.map(element => (
              <Grid
                item
                xs={6}
                md={4}
                data-aos="zoom-in-up"
                data-aos-delay={
                  isWidthUp("md", width) ? element.mdDelay : element.smDelay
                }
                key={element.headline}
              >
                <FeatureCard
                  Icon={element.icon}
                  color={element.color}
                  headline={element.headline}
                  text={element.text}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
}

FeatureSection.propTypes = {
  width: PropTypes.string.isRequired
};

export default withWidth()(FeatureSection);
